<div class="cell-wrapper">
  <div class="cell-name">
    <app-d-field-cell-text-table [row]="row" [column]="column" *ngIf="isText()"></app-d-field-cell-text-table>
    <app-d-field-cell-date-table [row]="row" [column]="column" *ngIf="isDatePicker()"></app-d-field-cell-date-table>
    <app-d-field-cell-file-table [row]="row" [column]="column" *ngIf="isFile()"></app-d-field-cell-file-table>
    <app-d-field-cell-dropdown-table [row]="row" [column]="column" *ngIf="isDropdown()"></app-d-field-cell-dropdown-table>
  </div>
</div>
